export const MODULE_SHARED_GATEWAY = 'shared_gateway';
export const MODULE_DEDICATED_GATEWAY = 'dedicated_gateway';
export const MODULE_BYOC_GATEWAY = 'byoc_gateway';
export const MODULE_SECRETS = 'secrets';
export const MODULE_AUDIT_LOGS = 'audit_logs';

export const MODULE_GATEWAY = 'gateway';

export const GATEWAY_MODULES = [
    MODULE_GATEWAY,
    MODULE_SHARED_GATEWAY,
    MODULE_DEDICATED_GATEWAY,
    MODULE_BYOC_GATEWAY
];
